// Loader guide passo-passo (5 lingue: it, en, es, fr, de)
import { GUIDES_IT, GUIDES_EN } from "./helpGuides.core";
import { GUIDES_ES, GUIDES_FR, GUIDES_DE } from "./helpGuides.intl";

const BY_LANG = { it: GUIDES_IT, en: GUIDES_EN, es: GUIDES_ES, fr: GUIDES_FR, de: GUIDES_DE };

// Titoli compatti [it, en, es, fr, de]
export const GUIDE_TITLES = {
  dashboard: ["Pannello di controllo", "Dashboard", "Panel de control", "Tableau de bord", "Übersicht"],
  cassa: ["Cassa", "POS", "Caja", "Caisse", "Kasse"],
  prenotazioni: ["Prenotazioni", "Reservations", "Reservas", "Réservations", "Reservierungen"],
  orders: ["Ordini", "Orders", "Pedidos", "Commandes", "Bestellungen"],
  production: ["Produzione", "Production", "Producción", "Production", "Produktion"],
  partners: ["Clienti", "Customers", "Clientes", "Clients", "Kunden"],
  suppliers: ["Fornitori", "Suppliers", "Proveedores", "Fournisseurs", "Lieferanten"],
  caldane: ["Caldane", "Caldane", "Caldane", "Caldane", "Caldane"],
  ricorrenti: ["Ordini ricorrenti", "Recurring orders", "Pedidos recurrentes", "Commandes récurrentes", "Dauerbestellungen"],
  torte: ["Torte", "Cakes", "Tartas", "Gâteaux", "Torten"],
  panettoni: ["Panettoni", "Panettoni", "Panettoni", "Panettoni", "Panettoni"],
  avanzi: ["Avanzi", "Leftovers", "Sobrantes", "Invendus", "Retouren"],
  waste: ["Sprechi", "Waste", "Mermas", "Pertes", "Verluste"],
  preventivi: ["Preventivi", "Quotes", "Presupuestos", "Devis", "Angebote"],
  b2b: ["B2B", "B2B", "B2B", "B2B", "B2B"],
  messages: ["Messaggi", "Messages", "Mensajes", "Messages", "Nachrichten"],
  recipes: ["Prodotti", "Products", "Productos", "Produits", "Produkte"],
  formula: ["Ricettario", "Recipe book", "Recetario", "Livre de recettes", "Rezeptbuch"],
  lab: ["Laboratorio", "Lab", "Laboratorio", "Laboratoire", "Labor"],
  inventory: ["Magazzino", "Stock", "Almacén", "Stock", "Lager"],
  inventario: ["Inventario", "Inventory", "Inventario", "Inventaire", "Inventur"],
  catalog: ["Catalogo", "Catalog", "Catálogo", "Catalogue", "Katalog"],
  listino: ["Listini", "Price lists", "Tarifas", "Tarifs", "Preislisten"],
  foodcost: ["Food cost", "Food cost", "Food cost", "Food cost", "Food Cost"],
  acquistati: ["Acquistati", "Purchased", "Comprados", "Achetés", "Zugekauft"],
  eventi: ["Giornate speciali", "Special days", "Días especiales", "Journées spéciales", "Sondertage"],
  reorder: ["Riordino", "Reorder", "Reposición", "Réassort", "Nachbestellung"],
  shifts: ["Turni", "Shifts", "Turnos", "Plannings", "Schichten"],
  azienda: ["Azienda", "Company", "Empresa", "Entreprise", "Firma"],
  attendance: ["Presenze", "Attendance", "Presencias", "Présences", "Anwesenheit"],
  invoices: ["Fatture fornitori", "Supplier invoices", "Facturas proveedores", "Factures fournisseurs", "Lieferantenrechnungen"],
  staff: ["Dipendenti", "Staff", "Empleados", "Employés", "Mitarbeiter"],
  documents: ["Documenti", "Documents", "Documentos", "Documents", "Dokumente"],
  pastdocs: ["Storico documenti", "Past documents", "Histórico documentos", "Documents passés", "Dokumenthistorie"],
  payments: ["Pagamenti", "Payments", "Pagos", "Paiements", "Zahlungen"],
  stats: ["Statistiche", "Statistics", "Estadísticas", "Statistiques", "Statistiken"],
  reports: ["Report", "Reports", "Informes", "Rapports", "Berichte"],
  billing: ["Abbonamento", "Subscription", "Suscripción", "Abonnement", "Abo"],
  trash: ["Cestino", "Trash", "Papelera", "Corbeille", "Papierkorb"],
  foto: ["Galleria foto", "Photo gallery", "Galería de fotos", "Galerie photos", "Fotogalerie"],
  portal_customer: ["Portale clienti", "Customer portal", "Portal de clientes", "Portail clients", "Kundenportal"],
  portal_supplier: ["Portale fornitori", "Supplier portal", "Portal de proveedores", "Portail fournisseurs", "Lieferantenportal"],
  staff_clock: ["Timbratura dipendenti", "Staff clock", "Fichaje empleados", "Pointage employés", "Zeiterfassung"],
};

const LANG_IDX = { it: 0, en: 1, es: 2, fr: 3, de: 4 };

export const GUIDE_PATHS = {
  "/app": "dashboard",
  "/app/cassa": "cassa",
  "/app/prenotazioni": "prenotazioni",
  "/app/orders": "orders",
  "/app/production": "production",
  "/app/partners": "partners",
  "/app/suppliers": "suppliers",
  "/app/caldane": "caldane",
  "/app/ricorrenti": "ricorrenti",
  "/app/torte": "torte",
  "/app/panettoni": "panettoni",
  "/app/avanzi": "avanzi",
  "/app/waste": "waste",
  "/app/preventivi": "preventivi",
  "/app/b2b": "b2b",
  "/app/messages": "messages",
  "/app/recipes": "recipes",
  "/app/formula": "formula",
  "/app/lab": "lab",
  "/app/inventory": "inventory",
  "/app/inventario": "inventario",
  "/app/catalog": "catalog",
  "/app/listino": "listino",
  "/app/foodcost": "foodcost",
  "/app/acquistati": "acquistati",
  "/app/eventi": "eventi",
  "/app/reorder": "reorder",
  "/app/shifts": "shifts",
  "/app/azienda": "azienda",
  "/app/attendance": "attendance",
  "/app/invoices": "invoices",
  "/app/staff": "staff",
  "/app/documents": "documents",
  "/app/past-docs": "pastdocs",
  "/app/payments": "payments",
  "/app/stats": "stats",
  "/app/reports": "reports",
  "/app/billing": "billing",
  "/app/trash": "trash",
  "/app/foto": "foto",
  "/app/storico-produzione": "lab",
  "/app/labels-history": "lab",
};

export const guideKeyForPath = (pathname) => GUIDE_PATHS[pathname] || null;

export const guideSteps = (key, lang) => {
  const d = BY_LANG[lang] || BY_LANG.en;
  return d[key] || BY_LANG.en[key] || BY_LANG.it[key] || null;
};

export const guideTitle = (key, lang) => {
  const arr = GUIDE_TITLES[key];
  if (!arr) return key;
  return arr[LANG_IDX[lang] ?? 1] || arr[1];
};
